import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import type { DatePrice } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"

interface PriceHistoryProps {
	view: DatePrice[]
}

const messages = defineMessages({
	headline: {
		defaultMessage: "Price history",
		id: "inventorylist.priceHistory.headline",
	},
})

export const PriceHistory = ({ view }: PriceHistoryProps) => {
	return (
		<>
			<PText weight="bold">
				<FormattedMessage {...messages.headline} />
			</PText>
			<List>
				{view.map((item, index) => (
					<Row key={index}>
						<PText>{item.date} </PText>
						<Spacing>&#8212;</Spacing>
						<PText weight="bold">{item.price}</PText>
					</Row>
				))}
			</List>
		</>
	)
}

const Spacing = styled(PText)`
	margin: 0 ${spacingStaticXs};
`

const List = styled.div`
	margin-top: ${spacingStaticXs};
`

const Row = styled.div`
	display: flex;
	flex-direction: row;
`
